export default __webpack_public_path__ + "images/right-side.d7dda23359cdd6833c99a7a25600cae0.svg";